import { render, staticRenderFns } from "./VersaoModal.vue?vue&type=template&id=28445e68"
import script from "./VersaoModal.vue?vue&type=script&lang=js"
export * from "./VersaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports